import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { PpmCardsModel } from './procurement.models';
const money = (v: any) =>
  Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
export default class PpmSummaryPanel extends React.PureComponent<{
  cards?: PpmCardsModel;
}> {
  render() {
    const c = this.props.cards || ({} as PpmCardsModel);
    const items = [
      ['Total', money(c.total)],
      ['Fonctionnement', money(c.fonctionnement)],
      ['Investissement', money(c.investissement)],
      ['Lines', c.linecount || 0],
      ['Scheduled', c.scheduledcount || 0],
      ['Unscheduled', c.unscheduledcount || 0],
      ['Status', c.status || '-'],
    ];
    return (
      <Grid container spacing={2}>
        {items.map(([l, v]) => (
          <Grid size={{ xs: 4, sm: 3, md: 2 }} key={String(l)}>
            <Card>
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {l}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {v}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}
